import type { Order, OrderBy } from '@frontend/libs/types/query'
import type React from 'react'

import BlogItem from '@frontend/components/blog/BlogItem'
import BlogLoader from '@frontend/components/blog/BlogLoader'
import { usePost } from '@frontend/libs/hooks/usePost'

export interface BlogGridProps {
  limit: number
  order: Order
  orderby: OrderBy
}

function BlogGrid({
  limit,
  order,
  orderby,
}: Readonly<BlogGridProps>): React.JSX.Element {
  const { data, error, isLoading } = usePost({ limit, order, orderby })

  if (isLoading)
    return (
      <>
        <BlogLoader />
        <BlogLoader />
      </>
    )

  if (error) return <p>Error loading post.</p>

  const posts = data?.success ? data.data : []

  return (
    <div className="grid gap-6 md:grid-cols-2">
      {posts?.map((post) => (
        <BlogItem
          categories={post.categories}
          excerpt={post.excerpt}
          image={post.image}
          key={post.id}
          permalink={post.permalink}
          title={post.title}
        />
      ))}
    </div>
  )
}

export default BlogGrid
